import { get } from '../index';

export const mainAdminGetCompanies = () => {
  return get('/admin-panel');
};
